import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Bootstrap CSS + JS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Boxicons
import 'boxicons/css/boxicons.min.css';

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles'; // ✅ this is the important change


const theme = createTheme({
  palette: {
    mode: 'light',
  },
});
createRoot(document.getElementById('root')).render(
  // <StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  //</StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
